import React from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input} from 'reactstrap';

import {contractSearch, editContract} from '../actions';

export const Contracts = (props) => {
    return <div>
        <div className="row">
            <div className="col">
                <h1>Kontrakt</h1>
            </div>
            <div className="col text-right">
                <div className="pt-3">
                    <div className="btn-group" role="group" aria-label="Basic example">
                        <Link to={"/contracts/export/"} className="btn btn-secondary">Exportera</Link>
                    </div>
                </div>
            </div>
        </div>
        <div className="form form-group form-search">
            <input type="text" className="form-control" placeholder="Sök på namn, personnr, referens eller plats"
                   value={props.filter && props.filter.search} onChange={props.onSearchChange}/>
        </div>
        <div className="table-filter">
            <ul className="nav nav-tabs mb-0">
                <li className="nav-item">
                    <a className={ "nav-link " + (props.filter && props.filter.status == -1 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, -1)}>Alla</a>
                </li>
                <li className="nav-item">
                    <a className={ "nav-link " + (props.filter && props.filter.status == 0 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 0)}>Obehandlade</a>
                </li>
                <li className="nav-item">
                    <a className={ "nav-link " + (props.filter && props.filter.status == 1 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 1)}>Betalda</a>
                </li>
                <li className="nav-item">
                    <a className={ "nav-link " + (props.filter && props.filter.status == 2 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 2)}>Arkiverade</a>
                </li>
                <li className="nav-item">
                    <a className={ "nav-link " + (props.filter && props.filter.status == 3 ? 'active' : '') } href="#" onClick={props.onFilterChange.bind(null, 3)}>Ogiltiga</a>
                </li>
            </ul>
        </div>
        <ul className="list mt-0">
            <li className="list-header">
                <div className="row align-items-center">
                    <div className="col"></div>
                    <div className="col-2">
                        Datum
                    </div>
                    <div className="col-2">
                        Status
                    </div>
                </div>
            </li>
            {props.contracts && props.contracts.length == 0 && <li>
                <div className="row align-items-center">
                    <div className="col text-center">
                        <br />
                        <p>Inga kontrakt hittades.</p>
                        <br />
                    </div>
                </div>
            </li>}
            {props.contracts && props.contracts.map((contract, i) => {

                let contractStatus = 'Obehandlad';
                switch (contract.status) {
                    case 1:
                        contractStatus = 'Betald';
                        break;
                    case 2:
                        contractStatus = 'Arkiverad';
                        break;
                    case 3:
                        contractStatus = 'Ogiltig';
                        break;

                }

                    return <li key={contract.identity}>
                        <div className="row align-items-center">
                            <div className="col-1">
                                <h2><Link to={"/contracts/view/" + contract.id}>{contract.id}</Link></h2>
                            </div>
                            <div className="col">

                                <p className="small">{contract.event.title}</p>
                                <p className="small">{contract.ssn} &nbsp;|&nbsp; {contract.location}</p>
                                <p className="small">Modeller: {contract.models.map((model) => {
                                    return model.name;
                                }).join(', ')}</p>
                            </div>
                            <div className="col-2">
                                <Link to={"/contracts/view/" + contract.id}>Se detaljer</Link>
                            </div>
                            <div className="col-2">
                                {contract.date}
                            </div>
                            <div className="col-2 text-center">
                                <div
                                    className={props.toggled == contract.id ? 'dropdown show d-inline' : 'dropdown  d-inline'}>
                                    <a href="#" onClick={props.onToggle.bind(null, contract.id)}
                                       className={ contract.status == 0 ? 'col-2 text-danger' : 'col-2'}
                                       data-toggle="dropdown">
                                        {contractStatus} <i className="fa-light fa-angle-down small"></i>
                                    </a>
                                    <div className="dropdown-menu">
                                        <a className="dropdown-item"
                                           onClick={props.onStatusChange.bind(null, contract.id, 0)} href="#">Obehandlad</a>
                                        <a className="dropdown-item"
                                           onClick={props.onStatusChange.bind(null, contract.id, 1)} href="#">Betald</a>
                                        <a className="dropdown-item"
                                           onClick={props.onStatusChange.bind(null, contract.id, 2)}
                                           href="#">Arkiverad</a>
                                        <div className="dropdown-divider"></div>
                                        <a className="dropdown-item" onClick={props.toggleDelete} href="#">{props.deleteToggled ? 'Nej, jag ångrar mig' : 'Ta bort'}</a>
                                        {props.deleteToggled && <a className="dropdown-item text-danger" onClick={props.onStatusChange.bind(null, contract.id, 3)} href="#">Ja, jag vill ta bort</a>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

            })}
        </ul>
    </div>;
}

export default connect(state => state.contractState, (dispatch) => {
    return {
        onExport: () => {
            window.print();
        },
        onStatusChange: (id, status, e) => {
            e.preventDefault();
            editContract(dispatch, id, status);
        },
        onSearchChange: (e) => {
            contractSearch(dispatch, {
                search: e.target.value,
                filter: -1
            });
        },
        toggleDelete: (e) => {
            e.preventDefault();
            dispatch({
                type: 'CONTRACT_TOGGLE_DELETE'
            })
        },
        onToggle: (id, e) => {
            e.preventDefault();
            dispatch({
                type: 'CONTRACT_DROPDOWN_TOGGLE',
                id: id
            })
        },
        onFilterChange: (status, e) => {
            e.preventDefault();
            contractSearch(dispatch, {
                status: status
            });
        }
    }
})(Contracts);
